import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Tooltip, HighlightedFeaturesViewIcon } from '@frontend/components';

import { highlightViewTool } from 'modules/common/viewer/cadViewer/data/actions';
import { getIsHighlightViewActive } from 'modules/common/viewer/cadViewer/data/reducer';

import ViewerButton from '../components/ViewerButton';
import ViewerButtonTooltip from '../components/ViewerButtonTooltip';

const HighlightViewTool = ({
  isEnabled, // passed in as direct prop
}) => {
  const isActive = useSelector(getIsHighlightViewActive);
  const dispatch = useDispatch();
  const toggleHighlightView = useCallback(() => {
    dispatch(highlightViewTool.toggle());
  }, [dispatch]);
  return isEnabled ? (
    <Tooltip
      placement="bottom"
      label={
        <ViewerButtonTooltip
          firstLine="Highlighted features view"
          secondLine="Show all faces selected as features in full opacity and other faces as slightly transparent"
        />
      }
    >
      <ViewerButton
        isActive={isActive}
        aria-label="Highlighted features view"
        onClick={toggleHighlightView}
      >
        <HighlightedFeaturesViewIcon boxSize={3} />
      </ViewerButton>
    </Tooltip>
  ) : null;
};

export default HighlightViewTool;
